import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex pl-2 pt-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Claim ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" on Notifi. ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Complete this form to start the process of claiming a protocol on Notifi. Once claimed, you will be able to send alerts on behalf of the Protocol, manage Protocol Staking Settings and user levels, and configure smart contract alerts. ")
], -1)
const _hoisted_6 = { class: "row pt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " The following wallet will be associated with this Manager account. After the claim is complete, additional Manager wallets can be added for this protocol. ", -1)
const _hoisted_8 = { class: "row pt-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row pt-3" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserWallets = _resolveComponent("UserWallets")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, [
          _hoisted_3,
          _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.name) + " Protocol", 1),
          _hoisted_4
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_UserWallets, { primary: true })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_va_input, {
          label: "Manager's Name",
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          placeholder: "Joe Protocol"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_va_input, {
          class: "flex sm7",
          label: "Protocol Discord Server Invite",
          modelValue: _ctx.discordServer,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.discordServer) = $event)),
          placeholder: "https://discord.gg/8ryhkfkfk"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_va_input, {
          class: "flex sm5",
          label: "Manager's Discord User Name",
          modelValue: _ctx.discordUser,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.discordUser) = $event)),
          placeholder: "@protocolMaster"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_va_button, {
        onClick: _ctx.save,
        disabled: !_ctx.saveValid
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ], 64))
}